'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Step = require('./Step');

var _Step2 = _interopRequireDefault(_Step);

var _Steps = require('./Steps');

var _Steps2 = _interopRequireDefault(_Steps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Step2["default"].Steps = _Steps2["default"];
exports["default"] = _Step2["default"];
module.exports = exports['default'];